import React from 'react';

const arrowTopRight = () => {
    return (  
        <svg width="10" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 .969v7.487h-.832V2.388L.588 10.95 0 10.363 8.579 1.8H2.494V.97H10Z" fill="#fff"/></svg>
    );
}
 
export default arrowTopRight;